var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.4731V23.0612C24 23.5931 23.7893 24.1032 23.4142 24.4793C23.0391 24.8554 22.5304 25.0667 22 25.0667H17C16.4695 25.0667 15.9608 24.8554 15.5858 24.4793C15.2107 24.1032 15 23.5931 15 23.0612V18.0474C15 17.7815 14.8946 17.5264 14.7071 17.3383C14.5196 17.1503 14.2652 17.0447 14 17.0447H9.99999C9.73477 17.0447 9.48042 17.1503 9.29288 17.3383C9.10535 17.5264 8.99999 17.7815 8.99999 18.0474V23.0612C8.99999 23.5931 8.78928 24.1032 8.4142 24.4793C8.03913 24.8554 7.53042 25.0667 6.99999 25.0667H2C1.46957 25.0667 0.960858 24.8554 0.585786 24.4793C0.210713 24.1032 2.31098e-08 23.5931 2.31097e-08 23.0612V11.4731C-4.20535e-05 11.1955 0.0573739 10.921 0.168614 10.6668C0.279855 10.4127 0.442497 10.1844 0.646249 9.99656L10.6462 0.535594L10.66 0.521806C11.0282 0.186051 11.5079 0 12.0056 0C12.5033 0 12.9831 0.186051 13.3512 0.521806C13.3555 0.526711 13.3601 0.531317 13.365 0.535594L23.365 9.99656C23.5667 10.1854 23.7272 10.4141 23.8365 10.6682C23.9458 10.9223 24.0014 11.1964 24 11.4731Z",
    fill: "#DBE8FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.1798236ddc9e04300a0a44919c3d141d.svg";
export { ForwardRef as ReactComponent };